import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addMerchantAccountInfo, getMerchantPayOutChannelList } from "@/api/merchantOrder";
import infoList from "@/mixins/infoList";
export default {
  name: "AddContact",
  mixins: [infoList],
  data: function data() {
    var checkEmail = function checkEmail(rule, value, callback) {
      var mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error('邮箱不能为空'));
      }
      setTimeout(function () {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的邮箱格式'));
        }
      }, 100);
    };
    var checkPhone = function checkPhone(rule, value, callback) {
      var phoneReg = /[0-9]{10}$/;
      if (!value) {
        return callback(new Error('电话号码不能为空'));
      }
      setTimeout(function () {
        // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
        // 所以在前面加了一个+实现隐式转换

        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'));
        } else {
          console.log(value);
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error('电话号码格式不正确'));
          }
        }
      }, 100);
    };
    return {
      addContactList: {
        Name: '',
        BankAccountNo: '',
        PanNo: '',
        IFSCCode: '',
        BankName: '',
        Address: '',
        IPhone: '',
        Email: '',
        vpa: '',
        Remark: ''
      },
      rules: {
        Name: [{
          required: true,
          message: '请输入联系人名称',
          trigger: 'blur'
        }],
        BankAccountNo: [{
          required: false,
          message: '请输入银行账户',
          trigger: 'blur'
        }],
        PanNo: [{
          required: true,
          message: '请输入PanNo',
          trigger: 'blur'
        }],
        IFSCCode: [{
          required: true,
          message: '请输入身份证账号',
          trigger: 'blur'
        }],
        BankName: [{
          required: false,
          message: '请输入银行名称',
          trigger: 'blur'
        }],
        Address: [{
          required: true,
          message: '请输入联系地址',
          trigger: 'blur'
        }],
        IPhone: [{
          validator: checkPhone,
          trigger: 'blur'
        }, {
          required: true,
          message: '请输入联系地址',
          trigger: 'blur'
        }],
        Email: [{
          validator: checkEmail,
          trigger: 'blur'
        }, {
          required: true,
          message: '请输入ChannelId联系地址',
          trigger: 'blur'
        }],
        vpa: [{
          required: false,
          message: '请输入vpa',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    addSubmit: function addSubmit() {
      var _this = this;
      this.$refs.addContactForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var res;
          return regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!valid) {
                  _context.next = 2;
                  break;
                }
                _context.next = 1;
                return addMerchantAccountInfo(_this.addContactList);
              case 1:
                res = _context.sent;
                if (res.code == 0) {
                  _this.$message.success(res.msg);
                  _this.$refs.addContactForm.resetFields();
                  _this.$router.back();
                }
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};